"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SearchParamTypes;
(function (SearchParamTypes) {
    SearchParamTypes[SearchParamTypes["Date"] = 0] = "Date";
    SearchParamTypes[SearchParamTypes["Number"] = 1] = "Number";
    SearchParamTypes[SearchParamTypes["String"] = 2] = "String";
    SearchParamTypes[SearchParamTypes["Boolean"] = 3] = "Boolean";
})(SearchParamTypes = exports.SearchParamTypes || (exports.SearchParamTypes = {}));
